import styled from "@emotion/styled";
import React, {Component} from "react";
import {ReactComponent as Loading} from "../../assets/Loading.svg";

// Styles
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(var(--main-height) / 2);
  grid-column-start: 1;
  grid-column-end: 4;
`;

// End of Styles

class LoadingComponent extends Component {
    render() {
        return <Container><Loading/></Container>;
    }
}

export default LoadingComponent;
